import { createAction } from 'redux-actions';
import {
  ABOUT_LIST_FETCH,
  ABOUT_LIST_SUCCESS,
  ABOUT_LIST_FAILURE,
  DELETE_ABOUT_FETCH,
  DELETE_ABOUT_SUCCESS,
  DELETE_ABOUT_FAILURE
} from './actionTypes';
import api from '../../services/api';

//<<<---FETCH-LIST-OF-ABOUTS--->>>
export const aboutListFetch = createAction(ABOUT_LIST_FETCH);
export const aboutListSuccess = createAction(ABOUT_LIST_SUCCESS);
export const aboutListFailure = createAction(ABOUT_LIST_FAILURE);

export const fetchAbouts = () => async dispatch => {
  dispatch(aboutListFetch());
  try {
    const res = await api.get('about');
    dispatch(aboutListSuccess(res.data));
  } catch (error) {
    dispatch(aboutListFailure(error));
  }
};

//<<<---DELETE-ABOUT--->>>
export const deleteAboutFetch = createAction(DELETE_ABOUT_FETCH);
export const deleteAboutSuccess = createAction(DELETE_ABOUT_SUCCESS);
export const deleteAboutFailure = createAction(DELETE_ABOUT_FAILURE);

export const deleteAbout = (id, lang, callback) => async dispatch => {
  dispatch(deleteAboutFetch());
  try {
    const res = await api.post(`about/${id}/${lang}`, undefined, {
      headers: { 'X-HTTP-Method-Override': 'DELETE' }
    });
    dispatch(deleteAboutSuccess(res.data));
    callback();
  } catch (error) {
    dispatch(deleteAboutFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/AboutList/actions.js